import React from 'react';
import Button from '../../../UI/Button/Button';

const SearchPaginationBtns = (props) => {

    const onPrevClick = (event) => {
        event.preventDefault();
        props.nextClick(props.pageNumber-1)
    }

    const isPrevDisabled = () => {
        return props.pageNumber === 1
    }

    const onNextClick = (event) => {
        event.preventDefault();
        let newPageNumber = props.pageNumber + 1
        props.nextClick(newPageNumber)
    } 

    return (
        <div style={{textAlign:'center'}}>
            <Button id="prevBtn" btnType="Search" disabled={isPrevDisabled()} clicked={onPrevClick}>{"<Prev"}</Button>
            <Button id="nextBtn" btnType="Search" disabled={props.nextDisabled()} clicked={onNextClick}>{"Next>"}</Button>
        </div>
    )
}

export default SearchPaginationBtns;